// extracted by mini-css-extract-plugin
module.exports = {"content":"NotFoundPage-content","image":"NotFoundPage-image","title":"NotFoundPage-title","subtitle":"NotFoundPage-subtitle","btn":"NotFoundPage-btn"};